module.exports = __webpack_public_path__ + "img/28_65.95f5358e.png";